// Requires: bootstrap-datetimepicker

import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';

export default class DateTimePickerInput extends Component {
    static get propTypes() {
        return {
            disabled: PropTypes.boolean,
            options: PropTypes.object,
            onChange: PropTypes.func,
            format: PropTypes.string,
            value: PropTypes.object,
            defaultValue: PropTypes.object,
        };
    }

    constructor(props) {
        super(props);

        this.options = {...props.options};
        if (this.options.minDate == null) {
            delete this.options.minDate;
        }
        if (this.options.maxDate == null) {
            delete this.options.maxDate;
        }
    }

    componentDidMount() {
        this.$el = $(this.el).datetimepicker({
            format: this.props.format ? this.props.format : 'MM/DD/YYYY',
            useCurrent: false,
            date: this.props.defaultValue || this.props.value,
            ...this.options
        }).on('dp.change', event => {
            this.props.onChange && this.props.onChange(event);
        });
        this.dateTimePicker = this.$el.data('DateTimePicker');
    }

    componentDidUpdate(prevProps) {
        const isControlled = typeof this.props.value != 'undefined';
        if (isControlled) {
            if (prevProps.value != this.props.value) {
                this.dateTimePicker.date(this.props.value);
            }
        } else {
            if (prevProps.defaultValue != this.props.defaultValue) {
                this.dateTimePicker.date(this.props.defaultValue);
            }
        }
        if (prevProps.disabled != this.props.disabled) {
            if (this.props.disabled) {
                this.dateTimePicker.disable();
            } else {
                this.dateTimePicker.enable();
            }
        }
    }

    componentWillUnmount() {
        this.dateTimePicker.destroy();
        this.$el.off('dp.change');
    }

    render() {
        // eslint-disable-next-line no-unused-vars
        const {options, disabled, value, onChange, ...inputProps} = this.props;

        return (
            <input
                ref={el => this.el = el}
                type="text"
                placeholder="Select a date"
                onFocus={() => this.dateTimePicker.show()}
                {...inputProps}
            />
        );
    }
}
